import React from 'react';
import { useDashboard } from '../../contexts/DashboardContext';

const AddTeamMemberModal = () => {
  const {
    addTeamMember,
    newTeamMember,
    packages,
    products,
    setNewTeamMember,
    setShowAddTeamMember,
    setTeamMemberAvatarFile,
    setTeamMemberAvatarPreview,
    showAddTeamMember,
    teamMemberAvatarPreview,
  } = useDashboard();

  return (
    <>
        {/* Add Team Member Modal */}
        {showAddTeamMember && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-[150]">
            <div className="clara-card w-full max-w-[95vw] md:max-w-4xl rounded-lg overflow-hidden" style={{ border: 'none', outline: 'none' }}>
              <div className="modal-header-fixed px-8 py-6" style={{ backgroundColor: '#374051' }}>
                <h3 className="clara-heading-3 text-white" style={{ margin: 0, color: '#ffffff' }}>Add Team Member</h3>
              </div>
              <div className="modal-content-scroll p-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Basic Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Name</label>
                    <input
                      type="text"
                      value={newTeamMember.name}
                      onChange={(e) => setNewTeamMember({...newTeamMember, name: e.target.value})}
                      className="clara-input w-full"
                    />
                  </div>
                  <div>
                    <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Email</label>
                    <input
                      type="email"
                      value={newTeamMember.email}
                      onChange={(e) => setNewTeamMember({...newTeamMember, email: e.target.value})}
                      className="clara-input w-full"
                    />
                  </div>
                  <div>
                    <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Role</label>
                    <select
                      value={newTeamMember.role}
                      onChange={(e) => setNewTeamMember({...newTeamMember, role: e.target.value})}
                      className="clara-input w-full"
                    >
                      <option value="Agent">Agent</option>
                      <option value="Photographer">Photographer</option>
                      <option value="Photo Editor">Photo Editor</option>
                      <option value="Video Editor">Video Editor</option>
                      <option value="Manager">Manager</option>
                      <option value="Admin">Admin</option>
                    </select>
                  </div>
                  <div>
                    <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Phone</label>
                    <input
                      type="tel"
                      value={newTeamMember.phone}
                      onChange={(e) => setNewTeamMember({...newTeamMember, phone: e.target.value})}
                      className="clara-input w-full"
                    />
                  </div>
                </div>

                {/* Avatar Upload */}
                <div>
                  <label className="block clara-body-sm font-medium mb-2" style={{ color: 'var(--clara-secondary)' }}>Profile Picture</label>
                  <div className="flex items-center space-x-4">
                    {/* Avatar Preview */}
                    {teamMemberAvatarPreview ? (
                      <img 
                        src={teamMemberAvatarPreview}
                        alt="Avatar preview"
                        className="w-20 h-20 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center text-blue-400 font-semibold text-xl">
                        {newTeamMember.name ? newTeamMember.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : '?'}
                      </div>
                    )}
                    
                    {/* Upload Button */}
                    <div>
                      <input
                        type="file"
                        id="team-avatar-upload"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            const file = e.target.files[0];
                            setTeamMemberAvatarFile(file);
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setTeamMemberAvatarPreview(reader.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        className="hidden"
                      />
                      <label
                        htmlFor="team-avatar-upload"
                        className="clara-btn-secondary px-4 py-2 cursor-pointer inline-block"
                      >
                        Upload Photo
                      </label>
                      {teamMemberAvatarPreview && (
                        <button
                          type="button"
                          onClick={() => {
                            setTeamMemberAvatarFile(null);
                            setTeamMemberAvatarPreview(null);
                          }}
                          className="ml-2 text-sm text-red-600 hover:text-red-800"
                        >
                          Remove
                        </button>
                      )}
                      <p className="text-xs mt-1" style={{ color: 'var(--clara-medium-gray)' }}>
                        Max file size: 5MB (JPG, PNG, GIF)
                      </p>
                    </div>
                  </div>
                </div>

                {/* Working Hours */}
                <div>
                  <h4 className="clara-body font-medium mb-4" style={{ color: 'var(--clara-primary)' }}>Working Hours</h4>
                  <div className="space-y-3">
                    {Object.entries(newTeamMember.working_hours).map(([day, hours]) => (
                      <div key={day} className="flex items-center space-x-4">
                        <div className="w-24">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={hours.enabled}
                              onChange={(e) => setNewTeamMember({
                                ...newTeamMember,
                                working_hours: {
                                  ...newTeamMember.working_hours,
                                  [day]: { ...hours, enabled: e.target.checked }
                                }
                              })}
                              className="mr-2"
                            />
                            <span className="clara-body-sm font-medium" style={{ textTransform: 'capitalize', color: 'var(--clara-secondary)' }}>
                              {day}
                            </span>
                          </label>
                        </div>
                        {hours.enabled && (
                          <>
                            <input
                              type="time"
                              value={hours.start}
                              onChange={(e) => setNewTeamMember({
                                ...newTeamMember,
                                working_hours: {
                                  ...newTeamMember.working_hours,
                                  [day]: { ...hours, start: e.target.value }
                                }
                              })}
                              className="clara-input"
                            />
                            <span className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>to</span>
                            <input
                              type="time"
                              value={hours.end}
                              onChange={(e) => setNewTeamMember({
                                ...newTeamMember,
                                working_hours: {
                                  ...newTeamMember.working_hours,
                                  [day]: { ...hours, end: e.target.value }
                                }
                              })}
                              className="clara-input"
                            />
                          </>
                        )}
                        {!hours.enabled && (
                          <span className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>Closed</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Product Assignments */}
                <div>
                  <h4 className="clara-body font-medium mb-4" style={{ color: 'var(--clara-primary)' }}>Assign Services</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {products.filter(p => p.is_active !== false).map((product) => (
                      <label key={product.id} className="flex items-center">
                        <input
                          type="checkbox"
                          checked={newTeamMember.assigned_products.includes(product.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setNewTeamMember({
                                ...newTeamMember,
                                assigned_products: [...newTeamMember.assigned_products, product.id]
                              });
                            } else {
                              setNewTeamMember({
                                ...newTeamMember,
                                assigned_products: newTeamMember.assigned_products.filter(id => id !== product.id)
                              });
                            }
                          }}
                          className="mr-2"
                        />
                        <span className="clara-body-sm">
                          {product.name}
                        </span>
                      </label>
                    ))}
                    {products.length === 0 && (
                      <p className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>
                        No services available. Add services first to assign them to team members.
                      </p>
                    )}
                  </div>
                </div>

                {/* Package Assignments */}
                <div>
                  <h4 className="clara-body font-medium mb-4" style={{ color: 'var(--clara-primary)' }}>Assign Packages</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {packages.filter(p => p.is_active !== false).map((pkg) => (
                      <label key={pkg.id} className="flex items-center">
                        <input
                          type="checkbox"
                          checked={newTeamMember.assigned_packages?.includes(pkg.id)}
                          onChange={(e) => {
                            const currentPackages = newTeamMember.assigned_packages || [];
                            if (e.target.checked) {
                              setNewTeamMember({
                                ...newTeamMember,
                                assigned_packages: [...currentPackages, pkg.id]
                              });
                            } else {
                              setNewTeamMember({
                                ...newTeamMember,
                                assigned_packages: currentPackages.filter(id => id !== pkg.id)
                              });
                            }
                          }}
                          className="mr-2"
                        />
                        <span className="clara-body-sm">
                          {pkg.name}
                        </span>
                      </label>
                    ))}
                    {packages.length === 0 && (
                      <p className="clara-body-sm" style={{ color: 'var(--clara-medium-gray)' }}>
                        No packages available. Create packages first to assign them to team members.
                      </p>
                    )}
                  </div>
                </div>

                </div>
              </div>
              <div className="modal-footer-fixed px-8 py-6 border-t" style={{ borderColor: 'var(--clara-border)' }}>
                <div className="flex space-x-4">
                  <button
                    onClick={addTeamMember}
                    className="flex-1 clara-btn-primary py-3"
                  >
                    Add Team Member
                  </button>
                  <button
                    onClick={() => {
                      setShowAddTeamMember(false);
                      // Reset form
                      setNewTeamMember({
                        name: '',
                        email: '',
                        role: 'Agent',
                        phone: '',
                        working_hours: {
                          monday: { enabled: true, start: '09:00', end: '17:00' },
                          tuesday: { enabled: true, start: '09:00', end: '17:00' },
                          wednesday: { enabled: true, start: '09:00', end: '17:00' },
                          thursday: { enabled: true, start: '09:00', end: '17:00' },
                          friday: { enabled: true, start: '09:00', end: '17:00' },
                          saturday: { enabled: false, start: '09:00', end: '17:00' },
                          sunday: { enabled: false, start: '09:00', end: '17:00' }
                        },
                        assigned_products: []
                      });
                    }}
                    className="flex-1 clara-btn-secondary py-3"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default AddTeamMemberModal;
